'use strict';

const DEFAULT_OPTIONS = {
    interval: 30000,
};
class InteractionObserver {
    constructor(callback, options) {
        this.callback = callback;
        this.options = Object.assign(DEFAULT_OPTIONS, options);
        this.lastCheckedAt = Date.now();
        this.setLastInteractionTime = this.setLastInteractionTime.bind(this);
    }
    setLastInteractionTime() {
        this.lastInteractionAt = Date.now();
    }
    /**
     * Track whether the user is moving their mouse, scrolling, or clicking anywhere inside the
     *   window.
     */
    observe() {
        window.addEventListener('touchstart', this.setLastInteractionTime);
        window.addEventListener('mousemove', this.setLastInteractionTime);
        window.addEventListener('keydown', this.setLastInteractionTime);
        window.addEventListener('scroll', this.setLastInteractionTime);
        window.addEventListener('click', this.setLastInteractionTime);
        // Every `options.interval` milliseconds, check whether there has been a new interaction
        //   since we last checked.
        this.interval = setInterval(() => {
            // If there has been a new interaction, invoke the callback
            if (this.lastInteractionAt && this.lastInteractionAt >= this.lastCheckedAt) {
                this.callback();
            }
            // Update the last check time. This is more reliable than subtracting the `interval`
            //   from the current timestamp because intervals are not guaranteed to run exactly
            //   at the configured interval (particularly when in a background tab).
            this.lastCheckedAt = Date.now();
        }, this.options.interval);
    }
    /**
     * Disable the interaction monitoring
     */
    disconnect() {
        window.addEventListener('touchstart', this.setLastInteractionTime);
        window.addEventListener('mousemove', this.setLastInteractionTime);
        window.addEventListener('keydown', this.setLastInteractionTime);
        window.addEventListener('scroll', this.setLastInteractionTime);
        window.addEventListener('click', this.setLastInteractionTime);
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
}

module.exports = InteractionObserver;
//# sourceMappingURL=index.js.map
